
<script>
/**
	 * 菜单项目
*/
export default {
  name: 'MenuItem',
  // functional 作用
  functional: true,
  // functional: false,
  props: {
    // 图标
    icon: {
      type: String,
      default: ''
    },
    // 标题
    title: {
      type: String,
      default: ''
    }
  },
  // render 作用
  render(h, context) {
    const { icon, title } = context.props
    const vnodes = []
    // 虚拟节点
    if (icon) {
      vnodes.push(<svg-icon icon-class={icon}/>)
    }
    if (title) {
      vnodes.push(<span slot='title'>{(title)}</span>)
    }
    return vnodes
  }
}
</script>